import { Alert, Button, Select, Space } from "antd"
import { ApplicationStatus, MerchantStatusData } from "../../../domain/invoicing/rainforest"
import { useContext, useState } from "react"
import { AuthenticationContext } from "../../../AuthenticationContext"
import { useSetMerchantApplicationStatusMutation } from "../../../domain/invoicing/rainforestQueries"

type Props = {
  merchantStatusData?: MerchantStatusData
}

const SetMerchantStatusControl = ({ merchantStatusData }: Props) => {
  const [applicationStatus, setApplicationStatus] = useState<ApplicationStatus>('COMPLETED')
  const [isUpdating, setIsUpdating] = useState(false)
  const { currentUser } = useContext(AuthenticationContext)
  const isSuperUser = currentUser?.isSuperUser === true
  const setMerchantStatusMutation = useSetMerchantApplicationStatusMutation(() => {
    setIsUpdating(false)
  })

  const handleSetMerchantStatus = () => {
    setIsUpdating(true)
    setMerchantStatusMutation.mutate(applicationStatus)
  }

  const canShowControl = isSuperUser &&
    merchantStatusData?.isSandbox === true &&
    merchantStatusData?.merchantStatus === 'ONBOARDING' &&
    merchantStatusData?.applicationStatus === 'PROCESSING'

  if (!canShowControl) {
    return null;
  }

  return <Alert type="warning" message={<Space direction="vertical">
    <strong>Super User Option:</strong>
    <Space>
      <span>Set sandbox merchant application status to:</span>
      <Select
        options={[
          { label: 'Needs Information', value: 'NEEDS_INFORMATION' },
          { label: 'Completed', value: 'COMPLETED' },
          { label: 'Declined', value: 'DECLINED' }
        ]}
        value={applicationStatus}
        onChange={setApplicationStatus}
        popupMatchSelectWidth={false}
        style={{ width: 200 }}
        disabled={isUpdating}
      />
      <Button type="primary"
        onClick={handleSetMerchantStatus}
        loading={isUpdating}
        disabled={isUpdating}
      >Set Merchant Status</Button>
    </Space>
  </Space>} />
}

export default SetMerchantStatusControl